var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-table',{attrs:{"items":_vm.items,"fields":_vm.fields,"tbody-tr-class":_vm.rowClass}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }